import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  FetchStoreList,
  DeleteStoreRecord,
} from "../../../services/StoreServices";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";

import serach_icon from "../../../assets/images/icon/search-icon.svg";
import mail from "../../../assets/images/icon/mail.svg";
import dowanload_csv from "../../../assets/images/icon/downloadcsv.svg";
import delete_icon from "../../../assets/images/icon/delete.svg";
import edit_icon from "../../../assets/images/icon/edit.svg";
import right_arrow from "../../../assets/images/icon/right-arrow-table.svg";

import { CSVLink } from "react-csv";
import { Button } from "reactstrap";
import { downloadCSVReport } from "helpers/backend_helper";
import { getUserInfo } from "helpers/authHelper";
import { checkPermissionStatus } from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

function StoreList(props) {
  const { t } = useTranslation();
  const [storeData, setstoreData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const userInfo = getUserInfo();
  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const [csvData, setCSVData] = useState([]);

  const handleCSVDownload = async e => {
    e.preventDefault();

    if (storeData?.length === 0) {
      toast.error(t(`Location_Manager.No data available`));
      return;
    }

    let allData = JSON.parse(JSON.stringify(storeData)) || [];
    allData = allData?.map(el => {
      el.statusText = el?.status === 1 ? "Active" : "Inactive";
      return el;
    });

    try {
      setCSVData(allData || []);
      setTimeout(() => {
        let element = document.getElementById("downloadCSV");
        element.click();
      }, 1000);
    } catch (err) {}
  };

  useEffect(() => {
    getStoreList();
  }, []);

  const getStoreList = async () => {
    FetchStoreList()
      .then(res => {
        let response = decryptDataFromArray(res.data);
        if (response.status) {
          let data = response.data;
          data = data.filter(item => item.status === 1);
          setstoreData(data);
        } else {
          toast.error(t(`Location_Manager.No data available`));
        }
      })
      .catch(err => {
        toast.error(t(`Location_Manager.No data available`));
      });
  };

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allStores = storeData?.map(el => {
      if (el?.store_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setstoreData(allStores);
  };

  let columns = [
    // {
    //   dataField: "store_id",
    //   text: "Store Id",
    //   classes: "total",
    //   formatter: (cellContent, row) => {
    //     return (
    //       <div className="date-tabel">
    //         {/* <input
    //           defaultChecked={row?.checked || false}
    //           onClick={e => handleCheck(e, row?.id)}
    //           type="checkbox"
    //         /> */}
    //         <label>{row.id}</label>
    //       </div>
    //     );
    //   },
    // },

    {
      dataField: "serial_no",
      text: t(`Location_Manager.Serial No`),
      formatter: (cellContent, row, rowIndex) => {
        return rowIndex + 1; // Serial number starts from 1
      },
    },
    {
      dataField: "store_name",
      text: t(`Location_Manager.Store Name`),
      classes: "store-name mobile-city",
    },
    {
      dataField: "status",
      text: t(`Location_Manager.Status`),
      classes: "store-status mobile-city",
      formatter: (cell, row) => {
        return cell === 1
          ? t(`Location_Manager.Active`)
          : t(`Location_Manager.Inactive`);
      },
    },
  ];

  if (checkPermissionStatus("store-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`Location_Manager.Actions`),
      formatter: (cell, row) => {
        let storeId = row.id;

        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-store/${storeId}`}
                // title="Edit Region"
              >
                <img src={edit_icon} alt="edit_icon" />
                <span>{t(`Location_Manager.Edit Store`)}</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <div
                onClick={() => handleRejectedRecords(storeId)}
                className="text-success blue-icon  blue-color3"
                style={{ cursor: "pointer" }}
                to="#"
                // title="Delete"
              >
                <img src={delete_icon} alt="delete" />
                <span>{t(`Location_Manager.Delete`)}</span>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Location_Manager.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };
  // Delete Faqs
  const handleRejectedRecords = store_id => {
    DeleteStoreRecord(store_id)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        if (res?.status == 200) {
          let messages = toast.success(responseData?.message);
          getStoreList();
          // window.location.reload();
        } else {
          toast.error(responseData?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  //rohit-code//

  const options2 = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
    totalSize: storeData.length,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const renderCheck = el => {
    if (!query) {
      return true;
    }
    let searchItem = JSON.stringify(el)?.toLowerCase();
    if (searchItem?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

 
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  
   if (!checkPermissionStatus("store-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Location_Manager.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="pending-list-page feedbacks">
        <div className="outerTab-box-wrapper below-vacancy amsterresign pt-4 psos">
          <div className="store-list-page">
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                // aria-labelledby="pills-home-tab"
              >
                <div className="tabel-store table-responsive tabel-application tabel-application-auto  pb-3">
                  <div className="table-data-search moile-ar">
                    <div className="total-record">
                      <h5>
                        {t(`Location_Manager.Total Records`)}{" "}
                        <span>{storeData?.length || 0}</span>
                      </h5>
                    </div>
                    <div className="total-serachbar">
                      <div className="serach-bar-top">
                        <form className="form-inline">
                          <input
                            className="form-control mr-sm-2"
                            type="search"
                            placeholder={t(`Location_Manager.Search by Store`)}
                            aria-label="Search"
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                          />
                          <span>
                            <img src={serach_icon} alt="search" />
                          </span>
                        </form>
                      </div>
                      {checkPermissionStatus("store-list", "downloadcsv") && (
                        <div className="take-text">
                          <CSVLink
                            data={csvData}
                            headers={[
                              {
                                key: "id",
                                label: t(`Location_Manager.Store ID`),
                              },
                              {
                                key: "store_name",
                                label: t(`Location_Manager.Store Name`),
                              },
                              {
                                key: "statusText",
                                label: t(`Location_Manager.Status`),
                              },
                            ]}
                            filename={`storeList.csv`}
                            id="downloadCSV"
                          >
                            <Button
                              color="info"
                              onClick={e => handleCSVDownload(e)}
                              outline
                            >
                              <img src={dowanload_csv} alt="Download" />{" "}
                              {t(`Location_Manager.Download CSV`)}
                            </Button>
                          </CSVLink>
                        </div>
                      )}
                      {checkPermissionStatus("store-list", "create") && (
                        <Link to="/create-store" className="btn btn-primary">
                          {t(`Location_Manager.Create Store`)}
                        </Link>
                      )}

                      <div className="tale-text right-panel mobile-arrow mb-0">
                        <button
                          className="button left"
                          onClick={() => handleScroll("left")}
                          data-tooltip="Scroll Left"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        <button
                          className="button right"
                          onClick={() => handleScroll("right")}
                          data-tooltip="Scroll Right"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="timeto-hire-card userlist  when-data-low">
                    <div className="table-custome-class range-custome">
                      <div className="scroll-container">
                        <div className="table-pending-list">
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={storeData?.filter(renderCheck)}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                              hover
                              responsive
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StoreList;
